import { useVTab } from './hook';

export const VTabDivider = () => {
  const { twStyle } = useVTab();

  return (
    <div
      aria-label="v-tab-divider"
      className={twStyle.tabDivider}
      role="separator"
    >
      &nbsp;
    </div>
  );
};

VTabDivider.displayName = 'VTabDivider';
